<template>
  <div>
    <table class="table table-hover">
      <tr>
        <th style="width:25px" v-if="hasAppt">
          Provider
        </th>
        <th style="width:190px">Name</th>
        <th>E-Mail</th>
      </tr>
      <tbody style="cursor:pointer">
        <tr
          v-for="user in users"
          v-bind:key="user.id"
          @click="userClicked(user)"
        >
          <td v-if="hasAppt">
            <i
              class="fas fa-check-circle text-success"
              v-if="user.provider"
            ></i>
          </td>
          <td>
            {{ user.name }}
          </td>
          <td>
            {{ user.email }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: { users: null },
  data() {
    return { hasAppt: false, active: true };
  },
  mounted() {},
  inject: ["systemContextService"],
  created() {
    this.hasAppt = this.systemContextService.getSystem().hasAppt;
  },
  methods: {
    userClicked(item) {
      this.$emit("userSelected", item);
    },
  },
};
</script>

<style></style>
